export const FACEBOOK_URL = 'https://www.facebook.com/42cGroupe/'
export const TWITTER_URL = 'https://twitter.com/42cgroupe'
export const YOUTUBE_URL = 'https://www.youtube.com/channel/UCWfJqjcRtzVjiCMSLc1q-EA'
export const LINKEDIN_URL = 'https://fr.linkedin.com/company/42c-group'
export const BLOG_URL = 'https://blog.42c.fr/'
export const INSTAGRAM_URL = 'https://www.instagram.com/42cgroupe/'
